/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetPropertyRightKind = {
    Tenancy: 'Tenancy',
    CompanyShare: 'CompanyShare',
    CooperativeMembership: 'CooperativeMembership',
    Other: 'Other'
} as const;
export type AssetPropertyRightKind = typeof AssetPropertyRightKind[keyof typeof AssetPropertyRightKind];


export function instanceOfAssetPropertyRightKind(value: any): boolean {
    for (const key in AssetPropertyRightKind) {
        if (Object.prototype.hasOwnProperty.call(AssetPropertyRightKind, key)) {
            if (AssetPropertyRightKind[key as keyof typeof AssetPropertyRightKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetPropertyRightKindFromJSON(json: any): AssetPropertyRightKind {
    return AssetPropertyRightKindFromJSONTyped(json, false);
}

export function AssetPropertyRightKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetPropertyRightKind {
    return json as AssetPropertyRightKind;
}

export function AssetPropertyRightKindToJSON(value?: AssetPropertyRightKind | null): any {
    return value as any;
}

export function AssetPropertyRightKindToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetPropertyRightKind {
    return value as AssetPropertyRightKind;
}

